import { render, staticRenderFns } from "./Diller.vue?vue&type=template&id=10b2434f&scoped=true"
import script from "./Diller.vue?vue&type=script&lang=js"
export * from "./Diller.vue?vue&type=script&lang=js"
import style0 from "./Diller.vue?vue&type=style&index=0&id=10b2434f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2434f",
  null
  
)

export default component.exports